// WelcomeScreen — first-load decision screen (Enable / Skip app lock).
// Shown when `decision === 'pending'`.

import { useAppLock } from './AppLockContext';

export function WelcomeScreen() {
  const { enableEncryption, skipEncryption } = useAppLock();

  return (
    <div className="applock-screen" role="dialog" aria-modal="true">
      <div className="applock-card">
        <h1 className="applock-title">Welcome to Backsolve</h1>
        <p className="applock-lead">
          This calculator stores cap tables and valuations locally in your
          browser. Would you like to protect access with a password?
        </p>
        <ul className="applock-bullets">
          <li>A password keeps prying eyes off sensitive equity data.</li>
          <li>You can enable, change, or remove it at any time in Settings.</li>
          <li>Choosing &ldquo;Skip&rdquo; is fine — you can enable it later.</li>
        </ul>
        <div className="applock-actions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={enableEncryption}
            autoFocus
          >
            Enable App Lock
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={skipEncryption}
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}
